import AdminLoadable from 'components/core/AdminLoadable';

export default AdminLoadable({
  loader: () => import('./ChannelOfflineGoLiveOverlay'),
  name: 'ChannelOfflineOverlay',
});
